import { useLayoutEffect } from 'react';
import useIsMobile from 'hooks/useIsMobile';

function useScrollToTop(dependency: unknown) {
  const isMobile = useIsMobile();

  useLayoutEffect(() => {
    const scrollElement = isMobile
      ? window
      : document.getElementsByTagName('main')[0];
    if (scrollElement) {
      scrollElement.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [dependency, isMobile]);
}

export default useScrollToTop;
